import { initPaymentHistoryTable } from './table.js';

export function initPaymentHistory() {
	initPaymentHistoryTable();
}
